<template>
    <div>
      <!-- Menu Button (Top-Right) -->
      <button @click="toggleMenu" class="menu-btn">
        ☰
      </button>
  
      <!-- Sidebar Menu -->
      <div class="side-menu" :class="{ 'open': isOpen }">
        <button @click="toggleMenu" class="close-btn">×</button>
        <div class="VerticalSpacer"></div>
        <slot></slot> <!-- Allows custom menu items -->
        <div class="SidemenuButton" id="H_Btn_Upload"><span page="import" @click="OpenPage" title="データをインポートする">データインポート</span></div>
        <div class="SidemenuButton" id="H_Btn_Samples"><span page="samples" @click="OpenPage" title="直販出荷保留リスト">直販出</span></div>
        <div class="SidemenuButton" id="H_Btn_Estimations"><span page="estimations" @click="OpenPage" title="見込比較">見込比較</span></div>
        <div class="SidemenuButton" id="H_Btn_ReturnItems"><span page="molds" @click="OpenPage" title="金型">金型</span></div>
        <div class="SidemenuButton" id="H_Btn_ReturnItems"><span page="returneditems" @click="OpenPage" title="返品商品">返品商品</span></div>
        <div class="SidemenuButton" id="H_Btn_Zaiko"><span page="sales" @click="OpenPage" title="在庫明細">在庫明細</span></div>
        <div class="SidemenuButton" id="H_Btn_Keikakumeisai"><span page="keikakumeisai" @click="OpenPage" title="計画明細">計画明細</span></div>
        <div class="SidemenuButton" id="H_Btn_Analytics"><span page="analytics" @click="OpenPage" title="分析">分析</span></div>
        <div class="SidemenuButton" id="H_Btn_Analytics"><span page="ai" @click="OpenPage" title="分析">SACHIKO-AI</span></div>
        <div class="SidemenuButton LogoutButton" id="H_Btn_Logout"><span @click="OnLogout" title="ログアウト">ログアウト</span></div>
      </div>
  
      <!-- Overlay (Click to Close) -->
      <div v-if="isOpen" class="overlay" @click="toggleMenu"></div>
    </div>
</template>

<script>
export default {
    props:{
        OnClick: Function,
        OnLogout: Function,
    },
data() {
    return {
    isOpen: false
    };
},
methods: {
    OpenPage(event)
    {
        this.OnClick(event);
        this.toggleMenu();
    },
    toggleMenu() {
        this.isOpen = !this.isOpen;
    }
}
};
</script>

<style scoped>
.VerticalSpacer
{
    display: grid;
    height: 25px;
}
/* Menu Button */
.menu-btn {
/* position: fixed; */
/* top: 15px;
right: 20px; */
background: rgba(0,0,0,0);
color: white;
border: none;
/* padding: 10px 15px; */
font-size: 20px;
cursor: pointer;
/* border-radius: 5px; */
}

/* Sidebar Menu */
.side-menu {
position: fixed;
top: 0;
right: -300px; /* Initially Hidden */
width: 250px;
height: 100%;
background: #222;
color: white;
padding: 20px;
transition: right 0.3s ease-in-out;
box-shadow: -3px 0 5px rgba(0, 0, 0, 0.2);
z-index: 2;
}

/* Show menu when open */
.side-menu.open {
right: 0;
}

/* Close Button */
.close-btn {
background: none;
border: none;
color: white;
font-size: 24px;
cursor: pointer;
position: absolute;
top: 10px;
right: 15px;
}

/* Overlay (Dark Background) */
.overlay {
position: fixed;
top: 0;
left: 0;
width: 100%;
height: 100%;
background: rgba(0, 0, 0, 0.5);
z-index: 1;
}
</style>